<template>
    <v-app>
      <!-- <v-navigation-drawer
        :clipped="$vuetify.breakpoint.lgAndUp"
        :mini-variant="miniDrawer"
        v-model='drawer'
        fixed
        width="200"
        app
      >
        <v-list dense>
            <v-list-tile
              v-for='item in menuItems'
              :key='item.title'
              :to='item.link'>
              <v-list-tile-action>
                  <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>{{ item.title }}</v-list-tile-content>
            </v-list-tile>

            <v-divider v-if="isAdminUser || isManagerUser"></v-divider>
            <v-subheader v-if="isAdminUser">Admin</v-subheader>
            <template v-for='item in adminItems'>
              <v-list-tile :key='item.title' :to='item.link'>
                <v-list-tile-action>
                    <v-icon>{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>{{ item.title }}</v-list-tile-content>
              </v-list-tile>
            </template>

            <v-divider></v-divider>
            <v-list-tile @click="onLogout">
              <v-list-tile-action>
                  <v-icon>exit_to_app</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>Logout</v-list-tile-content>
            </v-list-tile>
        </v-list>
        <v-footer class="pa-3" fixed>
          <v-btn icon @click.stop="miniDrawer = !miniDrawer">
            <v-icon v-html="miniDrawer ? 'chevron_right' : 'chevron_left'"></v-icon>
          </v-btn>
        </v-footer>
      </v-navigation-drawer> -->
      <v-app-bar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        dark
        app
        fixed
      >
        <!-- <v-toolbar-title>
          <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        </v-toolbar-title> -->
        <router-link to='/' tag='span' style='cursor: pointer' class="hidden-sm-and-down">
            <img src="@/assets/logo.png" alt="DivorceAnswered.com.au">
            {{version}}
        </router-link>
        <v-spacer></v-spacer>
        <v-toolbar-items class='hidden-xs-only'>
          <template v-for='item in menuItems'>
            <v-btn icon v-if="item.icon"
              :key='item.title'
              :to='item.link'>
              <v-icon>{{ item.icon }}</v-icon>
            </v-btn>
            <v-btn v-else
              text
              :key='item.title'
              :to='item.link'>
              {{ item.title }}
            </v-btn>
          </template>
          <v-btn text @click='onLogout'>Logout</v-btn>
        </v-toolbar-items>
        </v-app-bar>
        <v-content>
          <router-view></router-view>
        </v-content>
        <app-footer></app-footer>
        <app-notification-snackbar></app-notification-snackbar>
    </v-app>
</template>

<script>
export default {
  data: () => ({
    drawer: null,
    miniDrawer: false,
    version: process.env.VUE_APP_VERSION
  }),
  computed: {
    menuItems () {
      const menuItems = [
        {
          title: 'Home',
          link: '/'
        },
        {
          title: 'Account',
          link: '/account/'
        }
      ]
      // if (this.isAdminUser) {
      //   menuItems.splice(2, 0, {
      //     icon: 'device_hub',
      //     title: 'UCORDs',
      //     link: '/ucords/'
      //   })
      // }
      return menuItems
    },
    adminItems () {
      const adminItems = []
      if (this.isAdminUser) {
        adminItems.push({
          icon: 'supervisor_account',
          title: 'Organisation',
          link: '/organisations/'
        })
      } else if (this.isManagerUser) {
        adminItems.push({
          icon: 'supervisor_account',
          title: 'Users',
          link: '/accounts/'
        })
      }
      return adminItems
    },
    isAdminUser () {
      return this.$store.getters.isAdminUser
    },
    isManagerUser () {
      return this.$store.getters.isManagerUser
    }
  },
  methods: {
    onLogout () {
      this.$store.dispatch('logout')
    }
  }
}
</script>
